<div class="shipment-schedule__frequency">
  <input 
    #shipmentInput
    type="text"
    inputmode="numeric"
    name="numberOfShipments"
    class="shipment-schedule__input" 
    [attr.aria-label]="'autoShip.schedule.numberOfShipmentsLabel' | cxTranslate"/>

  <span class="shipment-schedule__text">
    {{ 'autoShip.schedule.shipmentsThisYear' | cxTranslate }}
  </span>
</div>
